import 'jquery';
import 'Vendor/fancybox/jquery.fancybox.min';
import 'Lib/fancybox-custom/fancybox-custom';
import 'Lib/font-load/font-load';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Lib/touch-retina-to-html-tag/touch-retina-to-html-tag';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { speed } from 'Lib/speed/speed';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/popup18/popup18';
import 'Bem/site/spoiler/spoiler';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Lib/on-width-resize/on-width-resize';
import 'Bem/site/sales-book/sales-book';
import 'Bem/site/link-drop-down/link-drop-down';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/copy/copy';
import 'Bem/site/tabs/tabs';
import 'Bem/site/auth/auth';
import 'Bem/site/auth-form/auth-form';
import 'Bem/site/form/form';
import 'Lib/vkontakte/vkontakte';
import 'Bem/site/book-page/book-page';
import Lottie from 'lottie-web';
import { isTouch } from 'Lib/istouch/istouch';
import { onScreen } from 'Lib/on-screen/on-screen';
import { Reactions } from 'Lib/reactions/reactions';
// import { whiteLabel } from 'Lib/white-label/white-label'; Скрываем до появления новой ЧГ корзины
import { formatPrice } from 'Lib/format-price/format-price';
import { eventSender } from 'Lib/event-sender/event-sender';
import { FastViewBookShowNotPopup } from 'Lib/fast-view-book/fast-view-book-show-not-popup';

// window.whiteLabel = whiteLabel;

const $body = $('body');
let reactions = new Reactions(document.querySelectorAll('.reactions'));
const pathAnimation = `${window.URLBuild}/images/landing/charity/img/json-animation/`;
const $bookItem = $('.charity__book-item');
// Переменные для слайдеров
const cSliderOn = 'owl-carousel';
const $charityBookBoxSlider = $('.charity__book-box_slider');
const $charityGenreBox = $('.charity__section-genre-box');
const $charityBoolsTop10Box = $('.charity__books-top10-box');
//
// Переменные для вставки аяксом карточки книги (fast-view-book)
const $charityBook = $('.charity__book');
const fastViewBook = new FastViewBookShowNotPopup($charityBook.attr('data-id'));
const formatBook = $charityBook.attr('data-format');
let indexTab;
//

// Функции установки аналитики на добавление в корзину/просмотр карточки книги
function gaEcommerceView($target) {
    onScreen($target, ($el) => {
        const $book = $el.first();

        if ($book.length) {
            sendGA4($book, 'impressions');
        }
    }, 0, 0, 0.8);
}

function sendGA4(elCurrAddedBook, typeEvent) {
    if (elCurrAddedBook) {
        const $book = elCurrAddedBook;

        if ($book.length) {
            const oldPrice = Number(formatPrice($book.find('.charity__price-old').text()));
            const price = Number(formatPrice($book.find('.charity__price-cur').text()));
            const isPreorder = Number($book.find('.btn-shop').first().text().trim().includes('Предзаказ'));
            const $btnBasket = $book.find('.btn-shop');
            const btnBasketAttr = $btnBasket.attr('data-book24-widget-basket-button-title');
            const textBtnBasket = btnBasketAttr || $btnBasket.attr('data-book24-widget-order-button-title') || $btnBasket.text().trim();
            const objBookInfo = {
                price,
                isPreorder,
                textBtnBasket,
                name: $book.find('.charity__book-title').text().trim(),
                id: $book.attr('data-id'),
                oldPrice,
                discountPrice: oldPrice && price ? oldPrice - price : null,
                brand: $book.attr('data-brand'),
                author: $book.find('.charity__book-author').text().trim(),
                firstCategory: $book.attr('data-first-category'),
                lastCategory: $book.attr('data-last-category'),
                type: $book.attr('data-format'),
                list: elCurrAddedBook.closest('[data-ga-ecommerce-name]').attr('data-ga-ecommerce-name') || '',
                index: $book.attr('data-pos'),
            };

            eventSender.impressionsClickAddBasketBookGA4(objBookInfo, typeEvent);
        }
    }
}
//

// Функция установки слайдеров
function initSliders(selector, items, margin = 8) {
    if (getW() > eksmoBP.smMax) {
        selector.trigger('destroy.owl.carousel')
            .removeClass(cSliderOn)
            .addClass(cSliderOn)
            .owlCarousel({
                smartSpeed: speed,
                dots: false,
                nav: !isTouch(),
                navClass: !isTouch() ? ['charity__prev arrow arrow_prev arrow_shadow', 'charity__next arrow arrow_next arrow_shadow'] : '',
                navText: ['', ''],
                slideBy: items,
                items,
                margin,
            });
    } else {
        selector.trigger('destroy.owl.carousel');
    }
}
//

// Функция установки анимация lottie
function setAnimation(selector, path) {
    Lottie.loadAnimation({
        container: selector, // контейнер для анимации
        renderer: 'svg', // тип рендерера (может быть 'svg', 'canvas' или 'html')
        loop: true, // зацикливание анимации
        autoplay: true, // автоматический запуск анимации
        path, // путь к вашему JSON-файлу с анимацией
    });
}
//

// Установка аналитики
gaEcommerceView($bookItem);

$body.on('eksmoPagenavAjax', (e) => {
    gaEcommerceView($(e.target).find('.charity__book-item'));
});

/* События по клику на кнопку "В корзину"/"На Литрес"
Скрываем до появления новой ЧГ корзины
$body.on('addBookBasket.eksmo', (e, data) => {
    const currAddedBook = $(`.charity__book-item .btn-shop[data-book24-widget=${data.productId}]`).first();

    if (currAddedBook.length) {
        sendGA4(currAddedBook, 'addBasket');
    }
});
*/
//

// Установка анимаций
document.querySelectorAll('.charity__lottie-animation').forEach((item) => {
    setAnimation(item, `${pathAnimation}${item.dataset?.name}.json`);
});
//

// "Выключение" ссылки при клике на "Развернуть" в названиях книги
document.querySelectorAll('.charity__book-item').forEach((item) => {
    item.addEventListener('click', (e) => {
        if (e.target.classList.contains('spoiler__btn')) {
            e.preventDefault();
        }
    });
});
//

// Установка слайдеров
initSliders($charityBookBoxSlider, 5);
initSliders($charityGenreBox, getW() < 1450 ? 3 : 4, getW() < 1450 ? 15 : 30);
initSliders($charityBoolsTop10Box, getW() < 1900 ? 3 : 4);

$body.on('eksmoResizeWidth', () => {
    initSliders($charityBookBoxSlider, 5);
    initSliders($charityGenreBox, getW() < 1450 ? 3 : 4);
    initSliders($charityBoolsTop10Box, getW() < 1450 ? 3 : 4);
});
//

// Вставки аяксом карточки книги (fast-view-book)
if (formatBook === 'paper') {
    indexTab = 0;
} else if (formatBook === 'el') {
    indexTab = 1;
} else if (formatBook === 'audio') {
    indexTab = 2;
}

fastViewBook.show($charityBook, `.prices-card__tab[data-tab-index="${indexTab}"]`, true);
//
reactions.init();

$body.on('init.fastViewBook', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
});

svgSpriteLoader('/landing/charity/svg/sprite.svg?v=20181207');
